import { render } from "./PartListButton.vue?vue&type=template&id=63ef6156&ts=true"
import script from "./PartListButton.vue?vue&type=script&lang=ts"
export * from "./PartListButton.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__